import type { FaireProductEntity } from "../../entity_types/product";

export const p_uq548u6zz9: FaireProductEntity = {
  token: "p_uq548u6zz9",
  type: "product",
  name: "Tailored Sleeveless Blazer and Pants Set",
  brandToken: "b_nd6psatxbw",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/fa65b2101046ada7362cc4ea1d4f1b8f9dcb04cb06015f844af05ec24f93081b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/650cca71a971bdf6612466bc731c8e7639251a5b74ccb45142d773b926377ea4.jpeg",
    "https://cdn.faire.com/fastly/28b73dade24a5df56b37c42e4a72a6d34a8e8ca48b988c188621a13441c29b49.jpeg",
    "https://cdn.faire.com/fastly/90b37a8a3398117c187d714717f7d854bc5c96d5c914b9ed34a6dc77e8ecdcd9.jpeg",
    "https://cdn.faire.com/fastly/16b3d435691dcfb29ed4e23f5b8d975322f65550f700c5eded1be61d1c9ec8f8.jpeg",
    "https://cdn.faire.com/fastly/192cfb1092b3a1ff40a4a7451fc7ea967bdf8124565fedbeea3f8843024f5778.jpeg",
    "https://cdn.faire.com/fastly/5408ff8c703407da1656eaaa8e5b3c4514febe8c8109abb4a5b6de40036e936c.jpeg",
    "https://cdn.faire.com/fastly/589a76b813e7edb82b50dce655fe5f3b134f34d59c6fd1e8d0159731bacf599c.jpeg",
    "https://cdn.faire.com/fastly/fdf5a959fb5d6df13acb3c7608f16a9e6271b6d5751e3818bdc9d1efaf63a01c.jpeg",
    "https://cdn.faire.com/fastly/f105b95baf8a88b89fd0a74e0777b62373c1cc3df6c9ec9eaa1f1be19e02c1d7.jpeg",
  ],
  priceDollars: 39.4,
  description:
    "Tailored set with a sleeveless blazer-inspired top and pants. Features a fitted waist and straight-leg pants. Ideal for formal or workwear styling.\n\nFabric: 95% polyester,5% spandex\n\nWeight: 1.32 lb\n",
  tags: [],
  msrpDollars: 78.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:40.625Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
